/**
 * Link para um documento do Drive: `/meu-drive?openPreview=<uuid do arquivo>`. O
 * host repassa o param ao iframe do Drive, que vai até a pasta do arquivo e abre
 * a visualização (contrato no jusfy-drive-front: `docs/abrir-arquivo-por-link.md`).
 */
export const OPEN_PREVIEW_PARAM = 'openPreview';

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * UUID do arquivo na query string do host, ou `undefined` quando ausente ou
 * malformado. Só UUID passa: o valor entra na URL do iframe, então nada de texto
 * livre vindo de uma URL que o usuário pode editar.
 */
export function readOpenPreviewParam(search: string): string | undefined {
  const value = new URLSearchParams(search).get(OPEN_PREVIEW_PARAM)?.trim();

  return value && UUID_PATTERN.test(value) ? value : undefined;
}

/**
 * A query string sem o `openPreview`, mantendo os outros params (e o `?` só se
 * sobrar algum). Usada para tirar o link da barra de endereço do host depois que
 * o Drive já recebeu o id: sem isso um F5 reabriria a visualização.
 */
export function stripOpenPreviewParam(search: string): string {
  const params = new URLSearchParams(search);
  params.delete(OPEN_PREVIEW_PARAM);
  const rest = params.toString();

  return rest ? `?${rest}` : '';
}

